class UASizeGuideDrawer extends Drawer {
  constructor() {
    super();
  }
}

class UASizeGuideDrawerButton extends DrawerButton {
  static cache = {};

  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  async handleClick() {
    this.drawerTag = this.dataset.drawerTag;
    if (!this.drawerTag) {
      return;
    }

    this.drawer = document.querySelector(`${this.drawerTag}.size-guide-drawer--${this.productHandle}`);

    if (!this.drawer) {

      document.querySelectorAll('size-guide-drawer.size-guide-drawer--quick-buy').forEach(drawer => {
        drawer.remove();
      });

      await this.fetchSizeGuide();
      this.classList.remove('loading');
      this.drawer = document.querySelector(this.drawerTag);

      // Datalayer tracking
      document.dispatchEvent(new CustomEvent('update-tracking-buttons'));
    }

    setTimeout(() => {
      this.toggleDrawer();
    },  200);
  }

  async fetchSizeGuide() {
    // add loading class to this
    this.classList.add('loading');
    const url = `/products/${this.productHandle}`;

    // Check if the size guide is already cached
    if (UASizeGuideDrawerButton.cache[this.productHandle]) {

      document.body.appendChild(UASizeGuideDrawerButton.cache[this.productHandle]);
      return;
    }

    try {
      const response = await fetch(url);
      const data = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const sizeGuideDrawer = doc.querySelector('size-guide-drawer');

      if (sizeGuideDrawer) {

        UASizeGuideDrawerButton.cache[this.productHandle] = sizeGuideDrawer.cloneNode(true);
        sizeGuideDrawer.classList.add('size-guide-drawer--quick-buy');
        document.body.appendChild(sizeGuideDrawer);
      } else {
        console.error('Size guide drawer element not found in the response');
      }
    } catch (error) {
      console.error('Error fetching size guide:', error);
    }
  }
}


class UASizeGuideRegion extends HTMLElement {
  constructor() {
    super();
    this.regions = [];
    this.selectedRegion = "all";
    this.areaEl = null;
    this.selectEl = null;
    this.handleRegionChange = this.handleRegionChange.bind(this);
    this.preselectLocation = false | (this.dataset.preselectLocation === "true");
  }

  connectedCallback() {
    this.selectEl = this.querySelector("select");
    this.areaEl = this.closest(".size-guide-drawer__content");
    this.regions = this.getAvailableRegions();

    if (this.regions.length === 0) {
      return;
    }

    this.populateSelectElement();
    this.selectEl.addEventListener("change", this.handleRegionChange);

    this.preselectVisitorLocation();
    this.showRegionSelector();
  }

  disconnectedCallback() {
    this.selectEl.removeEventListener("change", this.handleRegionChange);
  }

  showRegionSelector() {
    this.classList.remove("hidden");
  }

  preselectVisitorLocation() {
    if (this.preselectLocation) {
      window.fetchVisitorBrowsingContextSuggestions().then((visitorInfo) => {
        const visitorCountryName = visitorInfo.detected_values.country.name.toLowerCase();

        if (this.regions.includes(visitorCountryName)) {
          this.filterRegions(visitorCountryName);
          this.selectEl.value = visitorCountryName;
        }

      }).catch((error) => {
        console.error('Error fetching visitor info:', error);
      });
    }
  }

  populateSelectElement() {
    this.regions.forEach((region) => {
      const option = document.createElement("option");
      option.value = region;
      // capitalize first letter of words
      region = region.replace(/\b\w/g, (char) => char.toUpperCase());
      option.textContent = region;
      this.selectEl.appendChild(option);
    });
  }

  showAllRegions() {
    const tables = this.areaEl.querySelectorAll(".size-guide-table .size-guide-table__row[data-location]:not([data-location=''])");
    tables.forEach((table) => {
      table.style.display = "";
    });
  }

  filterRegions(selectedRegion) {
    const tables = this.areaEl.querySelectorAll(".size-guide-table");
    this.showAllRegions();

    selectedRegion = selectedRegion || this.selectedRegion;

    if (selectedRegion === "all") {
      return;
    }

    tables.forEach((table) => {

      if (!this.tableHasRegion(table, selectedRegion)) {
        return;
      }

      const regionColumns = table.querySelectorAll(".size-guide-table__row[data-location]:not([data-location=''])");

      regionColumns.forEach((regionColumn) => {
        const dataAttrLocation = regionColumn.getAttribute("data-location").toLowerCase();

        if (dataAttrLocation === selectedRegion) {
          regionColumn.style.display = "";
        } else {
          regionColumn.style.display = "none";
        }
      });
    });
  }

  tableHasRegion(table, region) {
    return table.querySelectorAll(`[data-location="${region}" i]`).length > 0;
  }

  handleRegionChange(event) {
    this.selectedRegion = event.target.value;
    this.filterRegions();
  }

  getAvailableRegions() {
    let regions = [];
    const UAsizeGuideTable = this.parentElement.querySelector("size-guide-table");
    const tables = UAsizeGuideTable.querySelectorAll(".size-guide-table .size-guide-table__row[data-location]:not([data-location=''])");
    tables.forEach((table) => {
      regions.push(table.getAttribute("data-location").toLocaleLowerCase());
    });

    regions = regions.filter((region, index, self) => self.indexOf(region) === index && region !== "");

    return regions;
  }
}

class UASizeGuideRegionSelect extends UASizeGuideRegion {
  constructor() {
    super();
  }
}

class UASizeGuideFilterButton extends DrawerButton {
  constructor() {
    super();
  }

  connectedCallback() {
    this.contentId = this.dataset.contentId;
    this.contentEls = document.querySelectorAll(`.size-guide-drawer__content[data-content-id="${this.contentId}"]`);
    this.filterButtons = document.querySelectorAll("size-guide-filter-button");

    this.addEventListener("click", this.handleClick);
  }

  handleClick() {
    if (this.classList.contains("disabled") || this.classList.contains("active")) {
      return;
    }

    this.updateButtons();
    this.updateCategoryVisibility();
    this.updateContentVisibility();
  }

  updateButtons() {
    const isCategoryButton = this.contentId.includes("category");
    const categoryNavEl = document.querySelector(".size-guide__filter-nav--cagtegory");

    for (const button of this.filterButtons) {
      const isButtonCategory = button.dataset.contentId.includes("category");

      if ((isCategoryButton && !isButtonCategory) || (!isCategoryButton && isButtonCategory)) {
        continue;
      }

      if (button.dataset.contentId === this.contentId) {
        button.classList.add("active", "button--outline");
      } else {
        button.classList.remove("active", "button--outline");
      }
    }

    if (!isCategoryButton && categoryNavEl) {
      const categoryButtons = categoryNavEl.querySelectorAll("size-guide-filter-button");

      for (const categoryButton of categoryButtons) {
        const categoryContentId = categoryButton.dataset.contentId;
        const hasClickedButton = document.querySelector(`.size-guide__category[data-content-id="${categoryContentId}"] .size-guide-drawer__content[data-content-id="${this.contentId}"]`);
        const buttons = document.querySelectorAll(`size-guide-filter-button[data-content-id="${categoryContentId}"]`);

        for (const button of buttons) {
          button.classList.toggle("disabled", !hasClickedButton);
        }
      }
    }
  }

  updateCategoryVisibility() {
    if (!this.contentId.includes("category")) {
      return;
    }

    const categoryEls = document.querySelectorAll(".size-guide__category");

    for (const categoryEl of categoryEls) {
      const isActive = categoryEl.dataset.contentId === this.contentId;
      categoryEl.classList.toggle("hidden", !isActive);
      categoryEl.classList.toggle("active", isActive);
    }
  }

  updateContentVisibility() {
    if (this.contentId.includes("category")) {
      return;
    }

    const contentEls = document.querySelectorAll(".size-guide-drawer__content");

    for (const contentEl of contentEls) {
      const isActive = contentEl.dataset.contentId === this.contentId;
      contentEl.classList.toggle("active", isActive);
      contentEl.classList.toggle("hidden", !isActive);
    }
  }
}

class UASizeGuideTable extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    const cells = this.querySelectorAll('.size-guide-table__cell');
    cells.forEach(cell => {
      cell.addEventListener('mouseenter', this.highlightCells.bind(this));
    });

    this.addEventListener('mouseleave', this.removeAllHighlightedCells.bind(this));
  }

  highlightCells(event) {
    this.removeAllHighlightedCells();

    const cell = event.target;
    const row = cell.closest('.size-guide-table__row');
    const colIndex = Array.from(row.children).indexOf(cell);

    cell.classList.add('highlight');
    row.classList.add('active-row');

    Array.from(row.children).forEach((rowCell, index) => {
      if (index <= colIndex) {
        rowCell.classList.add('highlight');
      }
    });

    const rows = this.querySelectorAll('.size-guide-table__row');
    for (let i = 0; i <= Array.from(rows).indexOf(row); i++) {
      const cellInRow = rows[i].children[colIndex];
      if (cellInRow) {
        cellInRow.classList.add('highlight');
      }
    }
  }

  removeAllHighlightedCells() {
    this.querySelectorAll('.size-guide-table__row').forEach(row => {
      row.classList.remove('active-row');
    });

    this.querySelectorAll('.size-guide-table__cell').forEach(cell => {
      cell.classList.remove('highlight');
    });
  }
}

customElements.define("size-guide-drawer", UASizeGuideDrawer);
customElements.define("size-guide-drawer-button", UASizeGuideDrawerButton);
customElements.define("size-guide-filter-button", UASizeGuideFilterButton);
customElements.define("size-guide-region-select", UASizeGuideRegionSelect);
customElements.define('size-guide-table', UASizeGuideTable);
